<template>
  <Layout :is-loading="isLoading">
    <div class="bloco">
      <HeaderPage
        :page-titles="pageTitles"
        :hide-button = "true"
      />
        <div>
    <b-tabs content-class="mt-3">
      <b-tab title="Criar Kit">
      <div class="col-md-2" style="max-width: 35.666667%;margin-left: -8px; margin-bottom: 23px " >
          {{ filial }}
            
          </div>
        <div class="row">
          <div class="col-md-2">
            <b-form-group
              id="input-group-1"
              label="Código do Insumo"
              label-for="input-1"
            >
              <b-form-input
                id="input-1"
                v-model="kit.codigo"
                type="text"
                placeholder=""
                required
              ></b-form-input>
            </b-form-group>
            
          </div>
          
          <div class="col-md-10">
            <b-form-group
              id="input-group-2"
              label="Descrição"
              label-for="input-2"
            >
              <b-form-input
                id="input-2"
                v-model="kit.descricao"
                placeholder=""
                required
              ></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <b-form-group
              id="input-group-2"
              label="Unidade"
              label-for="input-3"
            >
              <b-form-select id="input-3" v-model="kit.unidade" placeholder="">
                <template v-slot:first>
                  <b-form-select-option :value="kit.unidade" disabled>
                    {{ kit.unidade }}</b-form-select-option
                  >
                </template>
                <b-form-select-option
                  v-for="unidade in unidades"
                  :key="unidade._id"
                  :value="unidade.nome"
                >
                  {{ unidade.nome }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group
              id="input-group-3"
              label="Estoque Minimo"
              label-for="input-4"
            >
              <b-form-input
                id="input-4"
                v-model="kit.estoqueBaixo"
                required
              ></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <b-form-group
              id="input-group-3"
              label="Observação"
              label-for="input-5"
            >
              <b-form-textarea
                id="input-5"
                v-model="kit.obs"
                rows="6"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
          </div>
        </div>

        <div class="row">
          <div class="col-md-8 d-flex">
            <b-form-group
              id="input-group-1"
              label="Pesquisar Por Código"
              label-for="filter"
            >
              <b-input-group>
                <b-form-input
                  id="filter"
                  v-model="searchInsumo"
                  type="text"
                  placeholder="INSUMO..."
                ></b-form-input>
                <b-input-group-append
                  v-if="searchInsumo && searchInsumo.length >= 1"
                >
                  <b-button @click="searchForCode">Pesquisar Código</b-button>
                </b-input-group-append>
                <b-input-group-append v-else>
                  <b-button @click="listaInsumo(0)">Buscar Todos</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 d-flex">
            <b-table
              :fields="fields"
              :items="insumos"
              :current-page="currentPage"
              :per-page="10"
              selectable
              @row-clicked="onRowSelected"
            >
              <template v-slot:cell(descricao)="row">
                <span>{{ row.item.codigo }} - {{ row.item.descricao }}</span>
              </template>
            </b-table>
          </div>
          <div class="col-md-6 d-flex">
            <b-table
              fixed
              responsive
              :fields="fieldsSelected"
              :items="kit.subItens"
              :select-mode="selectMode"
              selectable
              @row-clicked="onRowRemove"
            >
              <template v-slot:cell(descricao)="row">
                <span>{{ row.item.codigo }} - {{ row.item.descricao }}</span>
              </template>
            </b-table>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-12 d-flex">
            <b-button variant="primary" @click="criarKit">Criar kit</b-button>
          </div>
        </div>
      </b-tab>
    </b-tabs>
  </div>
 
    </div>
  </Layout>
</template>
<script>

import listaUnidade from '@/src/services/unidadesObras'
import 'vue-multiselect-listbox/dist/vue-multi-select-listbox.css'
import insumoService from '@/src/services/serviceInsumoObra'
import alertMixin from '@/src/mixins/alertMixin'
import Layout from '@layouts/main'
import HeaderPage from '@/src/components/register/header-page.vue'
export default {
  components: { Layout, HeaderPage,  },
  mixins: [alertMixin],
  data() {
    return {
      isLoading: false,
      pageTitles: {
        title: 'Kit Insumo',
        subtitle: 'Cadastre aqui seus kits de insumos ',
      },
      insumo: {},
      searchInsumo: '',
      unidades: [],
      insumos: [],
      fields: [
        {
          key: 'descricao',
          label: 'Insumos para selecionar',
          sortable: true,
        },
      ],
      fieldsSelected: [
        {
          key: 'descricao',
          label: 'Insumos selecionados',
          sortable: true,
        },
      ],
      kit: {
        subItens: [],
      },
      currentPage: 0,
      selectMode: 'multi',
      selected: [],
      filial:''
 
   }
  },
    computed: {
    rows() {
      return this.insumos.length
    },
  },
  mounted() {
        this.onLoadData()
        this.updateByFiliais()
  },
  methods: {
    updateByFiliais(){
      this.filial = this.$store.state.itemSelecionado? `Filial: ${this.$store.state.itemSelecionado}` : ''
    },
        onLoadData() {
      if (this.insumo != undefined && this.insumo._id != undefined) {
        this.kit = this.insumo
      }
      this.listaUnidade()
      this.listaInsumo()
    },
    justNumber(e) {
      this.numeros = e.target.value.replace(/[^0-9]/g, '')
      this.searchInsumo = this.numeros
    },
    onRowSelected(item) {
      console.log(this.kit.subItens)
      this.kit.subItens.push(item)
    },
    onRowRemove(item) {
      this.kit.subItens.splice(this.kit.subItens.indexOf(item), 1)
    },
  

    async listaUnidade() {
      let { data } = await listaUnidade.list()
      this.unidades = data.data
    },
    async listaInsumo() {
      this.setLoading(true)
      insumoService.listByPage(0).then((res) => {
        const { data } = res.data
        this.insumos = data.results
        this.setLoading(false)
      })
    },
    async criarKit() {
      try {
        if(this.filial){
                  this.setLoading(true)
        this.kit.subItens.forEach((number, index) => {
            this.kit.subItens[index].subItens = []
        });
        
        this.kit.filial = this.$store.state.filial
        await insumoService.createKit(this.kit)
        this.kit = {}
        this.setLoading(false)
        this.successMessage('Salvo com sucesso')
        }else{ this.errorMessage('Selecione a Filial')}

      } catch (error) {
        console.log(error);
        this.setLoading(false)
        this.errorMessage('Erro ao salvar')
      }
    },
    async searchForCode() {
      this.setLoading(true)

      const state = this.$store.state
      const { user } = state.auth.currentUser

      const resultado = await insumoService.buscaCodigo(
        this.searchInsumo,
        user.tipo_conta,
        state.filter,
        state.filial
      )

      this.setLoading(false)
      if (resultado.data === undefined) {
        this.errorMessage('Erro ao Buscar Insumo')
        return
      }
      if (
        resultado.data.data.subItens != undefined &&
        resultado.data.data.subItens.length > 0
      ) {
        this.insumos = resultado.data.data.subItens
        this.insumos.unshift(resultado.data.data)
        return
      }
      this.insumos = [resultado.data.data]
      console.log(this.insumos)
      if (this.insumos[0] === null) {
        this.errorMessage('Nenhum Insumo encontrado')
      }
    },
    setLoading(loading) {
      this.isLoading = loading
    },
  
  },
}
</script>
<style src="../style.scss" lang="scss"></style>
